import PartnerContainer from "./container/PartnerContainer";
import "./SCSS/styles.css";
export default PartnerContainer;
